import { createContext, useContext, type RefObject } from "react"
import type {
  PopoverResolvedAlign,
  PopoverResolvedSide,
} from "@/v2-ui/popover/popover.utils"

export type SearchStatus = "idle" | "below-min" | "ready"

export type SelectorContextValue = {
  isLoading: boolean
  setIsLoading(isLoading: boolean): void
  shouldFilter: boolean
  searchStatus: SearchStatus
  setSearchStatus(status: SearchStatus): void
  minSearchLengthRef: RefObject<number>
  /** The trigger button, measured once per open to place the content. */
  triggerRef: RefObject<HTMLButtonElement | null>
  /** Where the content opens, locked for the whole time it is open. */
  side: PopoverResolvedSide
  align: PopoverResolvedAlign
}

const SelectorContext = createContext<SelectorContextValue | null>(null)

export function useSelectorContext() {
  const ctx = useContext(SelectorContext)
  if (!ctx) {
    throw new Error("Selector compound components must be used within Selector")
  }
  return ctx
}

export default SelectorContext
